<template>
  <div>
    <el-form-item :label="field.name + '：'" label-width="110px" id="image-list">
      <div class="redpacket-list">
        <draggable v-model="config[field.key]">
          <el-row class="redpacket-item" v-for="(item,index) in config[field.key]" :key="index" type="flex" justify="space-between">
            <div class="link-name" v-text="config[field.key][index]['name']"></div>
            <el-button size="small" @click="removeArticleItem(index)" class="del-btn">删除</el-button>
          </el-row>
        </draggable>
      </div>
      <el-button size="small" @click="openDialog">添加红包</el-button>
    </el-form-item>
    <!-- 店铺地址对话框 -->
    <el-dialog title="请选择红包" :visible.sync="dialog.visible" @close='closeDialog'>
      <red-packets @close='closeDialog' :idList="idList" @unSelect="unSelect" @select="select"></red-packets>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.link-name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
  padding-right: 20px;
}

.redpacket-list {
  margin-top: -5px;
}
.redpacket-item {
  cursor: pointer;
  padding: 5px 5px 5px 10px;
  &:hover {
    background: #f5f7fa;
  }
}

.del-btn {
  height: 32px;
  margin-top: 4px;
}
</style>

<script>
import Util from "@/js/util";
import _ from "lodash";
import draggable from "vuedraggable";

export default {
  name: "tms-type-red-packets",
  props: {
    field: {
      type: [Object, Array],
      required: true
    },
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      dialog: {
        visible: false
      },
      currentIndex: 0
    };
  },

  computed: {
    idList() {
      let list = [];
      this.config[this.field.key].map(val => {
        list.push(val.id);
      });
      return list;
    }
  },

  components: {
    draggable
  },

  created() {},

  methods: {
    openDialog() {
      this.dialog.visible = true;
    },
    removeArticleItem(index) {
      this.config[this.field.key].splice(index, 1);
    },
    handleUpload(src, index) {
      this.$set(this.config[this.field.key][index], image_url, src);
    },
    openDialog(index) {
      this.currentIndex = index;
      this.dialog.visible = true;
    },
    closeDialog() {
      this.dialog.visible = false;
    },
    select(row) {
      let item = _.cloneDeep(row);
      item.cms_url = "/cms/page/biz/item.html?id=" + item.id;
      item.discount_amount = Util.filterPriceToFen(item.discount_amount);
      this.config[this.field.key].push(item);
    },
    unSelect(row, index) {
      this.config[this.field.key].splice(index, 1);
    }
  }
};
</script>
